import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './sa_group_edit.routes';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import SaGroupService from '../../../components/api/sa_group/sa_group.service';

export class SaGroupEditController {
    /*@ngInject*/
    constructor($state, $stateParams, $mdDialog, SaGroupService, SaConfigService) {
        this.id = $stateParams.id;
        this.SaGroupService = SaGroupService;
        this.SaConfigService = SaConfigService;
        this.$state = $state;
        this.$mdDialog = $mdDialog;

        this.configIds = [];
        this.groupConfig = { id: this.id };

        this.submitted = false;

        this.dialog = {
            success: $mdDialog.alert({
                clickOutsideToClose:true,
                title: '設定を変更しました',
                content: '一覧 画面に移動します',
                ok: 'OK'
            }),
            error: $mdDialog.alert({
                clickOutsideToClose:true,
                title: 'エラーが発生しました',
                content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
                ok: 'OK'
            })
        };

        this.deleteDialog = {
            confirm: $mdDialog.confirm({
                clickOutsideToClose:true,
                title: '削除してよろしいですか?',
                ok: '削除する',
                cancel: '戻る'
            }),
            success: $mdDialog.alert({
                clickOutsideToClose:true,
                title: 'グループを削除しました',
                content: '一覧 画面に移動します',
                ok: 'OK'
            }),
            error: $mdDialog.alert({
                clickOutsideToClose:true,
                title: 'エラーが発生しました',
                content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
                ok: 'OK'
            })
        };
    }

    $onInit() {
        this.SaGroupService.api.show({ id: this.id },response => {
            this.groupConfig.name = response.name;
            this.groupConfig.memo = response.memo;

            this.configIds = response.config_ids;
        }, err => {
            if(err.status === 404 || err.status === 403) { this.$state.go('main.home'); }
        });

        this.SaConfigService.api.index(response => {
            this.configList = response;
        });
    }

    updateGroup(groupConfig, $event) {
        this.submitted = true;

        this.SaGroupService.api.update(
            angular.merge(groupConfig, { config_ids: this.configIds }),
            ok => {
                this.$mdDialog.show(this.dialog.success)
                    .finally(() => { this.$state.go('main.sa_group_index'); });
            },
            ng => {
                this.submitted = false;
                this.$mdDialog.show(this.dialog.error);
            }
        )
    }

    deleteGroup(ev) {
        this.submitted = true;

        this.$mdDialog.show(this.deleteDialog.confirm.targetEvent(ev))
            .then(() => {
                this.SaGroupService.api.delete(
                    { id: this.id },
                    ok => {this.$mdDialog.show(this.deleteDialog.success).finally(() => this.$state.go('main.sa_group_index')); },
                    ng => {
                        this.$mdDialog.show(this.deleteDialog.error);
                        this.submitted = false;
                    }
                )
            });
    }
}

export default angular.module('leptonApp.saGroupEdit', [uiRouter, SaGroupService, SaConfigService])
    .config(routing)
    .component('saGroupEdit', {
        template: require('./sa_group_edit.html'),
        controller: SaGroupEditController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/sa_group/edit/sa_group_edit.component.js